import MgInput from "./MgInput";

export default MgInput;